// --- GeoJSON feature highlight helpers ---
export const getGeometryEndpoints = (geometry) => {
    if (!geometry) return { first: null, last: null };
    switch (geometry.type) {
      case 'Point':
        return { first: geometry.coordinates, last: null };
      case 'LineString': {
        const c = geometry.coordinates;
        return { first: c[0] ?? null, last: c[c.length - 1] ?? null };
      }
      case 'MultiLineString': {
        const lines = geometry.coordinates;
        return {
          first: lines[0]?.[0] ?? null,
          last: lines[lines.length - 1]?.slice(-1)[0] ?? null,
        };
      }
      case 'Polygon': {
        const ring = geometry.coordinates[0] ?? [];
        return { first: ring[0] ?? null, last: ring[Math.floor(ring.length / 2)] ?? null };
      }
      case 'MultiPolygon': {
        const polys = geometry.coordinates;
        return {
          first: polys[0]?.[0]?.[0] ?? null,
          last: polys[polys.length - 1]?.[0]?.slice(-1)[0] ?? null,
        };
      }
      default:
        return { first: null, last: null };
    }
  };
  
  // GeoJSON coords are [lng, lat]; Leaflet needs [lat, lng]
  export const toLatLng = (coord) => (coord ? [coord[1], coord[0]] : null);
  
  export const getOriginLabel = (props) => {
    if (!props) return null;
    for (const k of ['from', 'FROM', 'origin', 'ORIGIN', 'source', 'SOURCE', 'start', 'START', 'src', 'SRC']) {
      if (props[k] != null) return String(props[k]);
    }
    return null;
  };
  
  export const getDestinationLabel = (props) => {
    if (!props) return null;
    for (const k of ['to', 'TO', 'destination', 'DESTINATION', 'target', 'TARGET', 'end', 'END', 'dst', 'DST']) {
      if (props[k] != null) return String(props[k]);
    }
    return null;
  };
  
  // Returns a colour string based on threshold_poor/below_average/average/good_<kpi> attributes,
  // or null when no threshold attributes are present.
  export const getFeatureColor = (properties) => {
    if (!properties) return null;

    if (properties.color) return properties.color;
  
    const kpiNames = Object.keys(properties)
      .filter((k) => k.startsWith('threshold_poor_'))
      .map((k) => k.slice('threshold_poor_'.length));
  
    for (const kpiName of kpiNames) {
      const value   = parseFloat(properties[kpiName]);
      if (isNaN(value)) continue;
  
      const poor    = parseFloat(properties[`threshold_poor_${kpiName}`]);
      const below   = parseFloat(properties[`threshold_below_average_${kpiName}`]);
      const average = parseFloat(properties[`threshold_average_${kpiName}`]);
      const good    = parseFloat(properties[`threshold_good_${kpiName}`]);
  
      if (!isNaN(poor)    && value >= poor)    return '#e74c3c'; // red
      if (!isNaN(below)   && value >= below)   return '#e67e22'; // orange
      if (!isNaN(average) && value >= average) return '#f1c40f'; // yellow
      if (!isNaN(good)    && value >= good)    return '#2ecc71'; // green
    }
  
    return null;
  };
  
  export const DEFAULT_GEOJSON_STYLE = { color: '#3388ff', weight: 3, opacity: 0.9, fillOpacity: 0.25 };

  export const GEOJSON_HIDDEN_PROPS = ['color', 'threshold_poor_', 'threshold_below_average_', 'threshold_average_', 'threshold_good_'];
          